import { Component } from '@angular/core';
import {  FormBuilder, FormGroup, Validators } from '@angular/forms';
import { VehiclesService } from 'src/app/services/vehicles/vehicles.service';

@Component({
  selector: 'app-import-reg-numbers',
  templateUrl: './import-reg-numbers.component.html',
  styleUrls: ['./import-reg-numbers.component.css']
})
export class ImportRegNumbersComponent {
  public errorMessage: string | null = null;
  public successMessage: string | null = null;
  form!: FormGroup;
  submitted: boolean = false;
  isProcessing: boolean = false;
  fileName: string="Choose an Excel file";
  excel_file: any;

  constructor(
    private formBuilder: FormBuilder,
    private vehiclesService:VehiclesService
  ){
    this.form = this.formBuilder.group({
      excel_file: [null, Validators.required],
    })
  }

  /**
   * Handle selectd file
   * @param event 
   */
  onFileSelected(event: any) {
    //Show selected file
    const fileInput = event.target as HTMLInputElement;
    this.fileName = fileInput.files?.[0]?.name ?? 'Choose an Excel file';

    //Prepare file for upload
    if (event.target.files && event.target.files.length) {
      const [file] = event.target.files;
      this.excel_file = file
    }
  }

  handleSubmit() {
    this.submitted = true;
    this.isProcessing = true;

    if (this.form.valid) {
      this.vehiclesService.import(this.excel_file)
      .subscribe({
        next: (response) => {
          if(response.status==='success'){
            this.submitted = false;
            this.isProcessing = false;
            this.successMessage=response.message;
            this.errorMessage=null;
          }else{
            this.submitted = false;
            this.isProcessing = false;
            this.errorMessage=response.message;
            this.successMessage=null
          }
        },
        error: (error) => {
          this.submitted = false;
          this.isProcessing = false;
          this.errorMessage=error;
          this.successMessage=null
        }
      });
    }else{
      this.isProcessing = false;
    }
  }
}
